export default __webpack_public_path__ + "static/media/user.a51f4cda.png";